<template>
    <section class="header-wrapper">
        <i class="el-icon-back" @click="goBack"></i>
        <span class="detail-type" @click="goBack">{{ title }}</span>
        <div :class="['fixed-title', {'is-show': isShowTitle}]" v-if="detailInfo.created_by">
            <el-popover
                popper-class="user-card"
                placement="top"
                :open-delay="500"
                width="400"
                trigger="hover"
                @show="$refs['card' + detailInfo.created_by.id].getUserInfo()">
                <div style="text-align: right; margin: 0, padding: 0">
                    <user-card :ref="`card${detailInfo.created_by.id}`" :user-id="detailInfo.created_by.id"></user-card>
                </div>
                <div slot="reference" class="user-avatar" @click="visible = !visible">
                    <div class="user-info-left" @click="$emit('toPersonal')">
                        <img class="identity-icon" width="32" height="32" src="../../images/personal_center/avatar_default.png" v-if="detailInfo.created_by.user_logo.substr(0,1)=='?'">
                        <img  :src="detailInfo.created_by.user_logo" alt=""  width="32" height="32" v-else>
                    </div>
                </div>
            </el-popover>
            <!-- <span class="questioner-name">{{detailInfo.created_by.nick_name}}</span> -->
            <span class="user-name">{{detailInfo.created_by.nick_name}}</span>
            <el-tooltip v-if="detailInfo.created_by.is_official" effect="light" content="蓝鲸智云官方" placement="right">
              <svg style="width: 20px; height: 20px" aria-hidden="true">
                  <use xlink:href="#icon-lanjingguanfang"></use>
              </svg>
            </el-tooltip>
            <el-tooltip v-if="detailInfo.created_by.is_vip" effect="light" content="核心用户" placement="right">
                  <span class="icon-vipuser"></span>
            </el-tooltip>
            <span class="question-title">{{ detailInfo.title }}</span>
            <template v-if="!isPreview && isEditor">
                <span class="editor-btn" @click="$emit('editQuestion')">编辑</span>
                <span class="delete-btn" @click="$emit('deletePop')">删除</span>
            </template>
        </div>
    </section>
</template>

<script>
import userCard from '../common/userCard.vue';
export default {
    components: {
        userCard
    },
    props: {
        title: {
            type: String,
            default: '问答专区'
        },
        isShowTitle: {
            type: Boolean,
            default: false
        },
        isEditor: {
            type: Boolean,
            default: false
        },
        isAnswer: {
            type: Boolean,
            default: true
        },
        detailInfo: {
            type: Object,
            default: () => {}
        },
        isPreview: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        goBack () {
            const path = this.isAnswer ? '/s-mart/community' : `/s-mart/community/article`
            this.$router.push({ path })
        }   
    }
}
</script>

<style lang="scss" scoped>
    .header-wrapper {
        position: fixed;
        top: 60px;
        left: 0;
        z-index: 999;
        height: 52px;
        width: 100%;
        min-width: 1200px;
        background: #ffffff;
        box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.10); 
        padding-left: 27px;
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #313238;
        overflow: hidden;
        .el-icon-back {
            cursor: pointer;
            font-size: 14px;
            margin-top: 3px;
            color: #3a84ff;
            font-weight: 700;
        }
        .detail-type {
            flex-shrink: 0;
            padding-left: 15px;
            cursor: pointer;
        }
        .fixed-title {
            display: flex;
            align-items: center;
            position: absolute;
            width: 1258px;
            top: 55px;
            transition: all .3s;
            &.is-show {
                top: 10px;
            }
        }
        .user-info-left {
            margin-right: 6px;
            flex-shrink: 0;
            img {
                border-radius: 50%;
                cursor: pointer;
            }
        }
        .user-name {
            font-size: 12px;
            line-height: 16px;
            font-weight: 700;
            flex-shrink: 0;
            cursor: pointer;
        }
        .question-title {
            font-weight: 700;
            margin: 0 48px 0 28px;
            overflow: hidden;
            white-space:nowrap;
            text-overflow:ellipsis;
            position: relative;
            top: -1px;
        }
        .editor-btn, .delete-btn {
            color: #63656e;
            font-size: 12px;
            margin-left: 20px;
            cursor: pointer;
            flex-shrink: 0;
            &:hover{
                color: #3a84ff;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// detailTitle.vue?72758f92